import { render, staticRenderFns } from "./HistorialSolicitudes.vue?vue&type=template&id=2bf97ed8"
import script from "./HistorialSolicitudes.vue?vue&type=script&lang=js"
export * from "./HistorialSolicitudes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports